import { ROLE, FULL_A, AAU_BIZ_OPS, XIAOMI } from '@/constants/roles'

// 菜单可见性说明:
// - 父菜单(有 children)无需配置,自动「任一子可见则可见」(见 menuPermission.isMenuVisible)
// - 叶子菜单用 roles 白名单控制;报单汇总额外用 accountIds 保留账号特例
// - 现有角色 1/2/3/4 可见性与改造前完全一致;新增 23 个角色(10000+)按 各职位后台功能权限配置.xlsx
const baseMenuConf = [
  {
    name: '用户管理',
    oname: 'team',
    icon: 'el-icon-s-custom',
    url: '/team',
    children: [{
      name: '子账号管理',
      oname: 'team-manage',
      url: '/team/team-manage',
      roles: [ROLE.CHANNEL_SUB] // 仅渠道子账号(role3)可见
    }, {
      name: '渠道用户管理',
      oname: 'user-manage',
      url: '/team/user-manage',
      roles: [ROLE.ADMIN, ...FULL_A, ROLE.M2S_OPS]
    }]
  },
  {
    name: '报表管理',
    oname: 'baodan',
    icon: 'el-icon-s-promotion',
    url: '/bd-manage',
    children: [{
      name: '高佣商品报表',
      oname: 'bd-report',
      url: '/bd-manage/overview',
      roles: [ROLE.ADMIN, ROLE.SECOND, ROLE.CHANNEL_SUB, ROLE.DOWNSTREAM, ROLE.FINANCE, ...FULL_A, ROLE.M2S_OPS]
    }, {
      name: '高佣结算佣金报表',
      oname: 'settlement-report',
      url: '/bd-manage/settlement-manage',
      roles: [ROLE.ADMIN, ROLE.SECOND, ROLE.CHANNEL_SUB, ROLE.FINANCE, ...FULL_A, ROLE.M2S_OPS] // 下游(role4)不可见
    }]
  },
  {
    name: '下游账号',
    oname: 'xyzh',
    icon: 'el-icon-user-solid',
    url: '/downstream',
    children: [{
      name: '下游用户管理',
      oname: 'downstream',
      url: '/downstream/account',
      roles: [ROLE.ADMIN, ROLE.SECOND, ROLE.CHANNEL_SUB, ...FULL_A, ROLE.M2S_OPS] // 下游(role4)不可见
    }]
  },
  {
    name: '高佣商品报单管理',
    oname: 'order-manage',
    icon: 'el-icon-goods',
    url: '/order-manage',
    children: [{
      name: '高佣商品报单用户',
      oname: 'user-list',
      url: '/order-manage/user-list',
      roles: [ROLE.ADMIN, ROLE.SECOND, ROLE.CHANNEL_SUB, ROLE.DOWNSTREAM, ...FULL_A, ROLE.M2S_OPS, ...AAU_BIZ_OPS]
    }, {
      name: '高佣商品报单列表',
      oname: 'order-list',
      url: '/order-manage/order-list',
      roles: [ROLE.ADMIN, ROLE.SECOND, ROLE.CHANNEL_SUB, ROLE.DOWNSTREAM, ...FULL_A, ROLE.M2S_OPS, ...AAU_BIZ_OPS]
    }, {
      name: '报单汇总',
      oname: 'order-summary',
      url: '/order-manage/order-summary',
      roles: [ROLE.ADMIN],      // 本次开放给管理员
      accountIds: [XIAOMI]      // 保留小米账号特例
    }, {
      name: '待复核补贴报单列表',
      oname: 'waiting-for-review',
      url: '/order-manage/waiting-for-review',
      roles: [ROLE.ADMIN, ...FULL_A, ROLE.M2S_OPS, ...AAU_BIZ_OPS] // 仅超管
    }]
  },
  {
    name: '专属商品报单管理',
    oname: 'zs-order-manage',
    icon: 'el-icon-s-goods',
    url: '/zs-order-manage',
    children: [{
      name: '专属商品报单用户',
      oname: 'zs-user-list',
      url: '/zs-order-manage/user-list',
      roles: [ROLE.ADMIN, ROLE.SECOND, ROLE.CHANNEL_SUB, ...FULL_A, ...AAU_BIZ_OPS] // 下游不可见;M2S运营不可见
    }, {
      name: '专属商品报单列表',
      oname: 'zs-order-list',
      url: '/zs-order-manage/order-list',
      roles: [ROLE.ADMIN, ROLE.SECOND, ROLE.CHANNEL_SUB, ...FULL_A, ...AAU_BIZ_OPS]
    }]
  },
  {
    name: '独家爆品报单管理',
    oname: 'sup-order-manage',
    icon: 'el-icon-s-order',
    url: '/sup-order-manage',
    children: [{
      name: '独家爆品报单列表',
      oname: 'sup-order-list',
      url: '/order-manage/sup-order-list',
      roles: [ROLE.ADMIN, ROLE.SECOND, ROLE.CHANNEL_SUB, ROLE.DOWNSTREAM, ...FULL_A, ...AAU_BIZ_OPS] // M2S运营不可见
    }]
  },
  {
    name: '选品库',
    oname: 'xpk',
    icon: 'el-icon-s-grid',
    url: '/xpk',
    children: [{
      name: '高佣商品选品库',
      oname: 'm2s',
      url: '/xpk/m2s',
      roles: [ROLE.ADMIN, ROLE.SECOND, ROLE.CHANNEL_SUB, ROLE.DOWNSTREAM, ...FULL_A, ROLE.M2S_OPS]
    }, {
      name: '独家爆品选品库',
      oname: 'sup',
      url: '/xpk/sup',
      roles: [ROLE.ADMIN, ROLE.SECOND, ROLE.CHANNEL_SUB, ROLE.DOWNSTREAM, ...FULL_A, ROLE.M2S_OPS]
    }, {
      name: '独家爆品约量记录',
      oname: 'sup-reserve-record',
      url: '/xpk/sup/reserve-record',
      roles: [ROLE.ADMIN, ROLE.SECOND, ROLE.CHANNEL_SUB] // 下游不可见
    }, {
      name: '渠道约量管理',
      oname: 'sup-channel-reserve-manage',
      url: '/xpk/sup/channel-reserve-manage',
      roles: [ROLE.ADMIN] // 仅超管可见
    }]
  },
  {
    name: '系统管理',
    oname: 'system',
    icon: 'el-icon-s-tools',
    url: '/system',
    children: [{
      name: '用户角色管理',
      oname: 'user-role',
      url: '/system/user-role',
      roles: [ROLE.ADMIN] // 仅管理员可见
    }]
  }
]

const baseMenuMap = {}

export {
  baseMenuConf,
  baseMenuMap
};
